import Swiper from 'swiper';
const hero = {

    init() {
        if ($('.jshero').length > 0) {
            this.initSlider();
        }
    },
    initSlider() {
        new Swiper($('.jshero')[0], {
            loop: true,
            speed: 700,
            autoplay: {
                delay: 2500,
                disableOnInteraction: true,
            },
            pagination: {
                el: '.swiperpagination',
                clickable: true,
            },
        });
    },
}
export default hero;


// WEBPACK FOOTER //
// ./scripts/modules/components/_hero.js